export const GOLDEN_BEE_ADDRESSES = [ // for only 2023 YEAR
  [], // January 
  [   // February
    'bears1z9z57uklctww7xfh3cjzukkwfmusxc0hz6negq',
    'bears1zcxsqdg0pxdmpqnqf5l4lhc5f5hps24h5sd5nv',
    'bears19nfn2kv9sznx9jg29dac3v5nq6x8l47qnveyjh',
    'bears1952dyzydd3wjtqe3x8y0lq57k6gg2ngj3g0a5e',
    'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
    'bears1fuheqqsx9lduy0qp2yd5ym5wupk8lrme8lglka',
    'bears12n7j75z7fk736snp32g84ahumuqfnhjemccez6',
    'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
    'bears1wde23h86vu5y7fsfhs85h5wsem9kckj7sny87c',
    'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
    'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
    'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
    'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
    'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
    'bears13gj4f4u3t069qpj4306vmtu366dm0d2fpclky2',
    'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
    'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
    'bears15qnf6turgmunhkvxrx0skvgw3apcwdp8uupphs',
    'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
    'bears1krgggg53fhcdvw94m5ftms63qj89pz08unw0g4',
    'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
    'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
    'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
    'bears1mdlky2kx6vqgxpmlvhmcpekl4evm0n6fppruu5',
    'bears1mwt4kdr9flj5l94r5ecthcmncdz5jk0nwd6hdq',
    'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
    'bears1uz90x7ntc5re5tpkmjp8dwgkhmj98t8m8ulq5e',
    'bears1azjav327vs63e0hfly05dayespg7d2sk6tp5gj',
    'bears1addld06nnzxwu6gaaqp3m9za2qcffdz83200sc',
    'bears1amajatl5v0n2egmraagltu2k6w3eg9x8tvmgdk',
    'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
    'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
    'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
    'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
    'bears1ywp9rcdhxxcnxvcv3tkephgssmjzp5f62mdycr',
    'bears1yma9ct0crd6zc6n9ru6f44fcjcmj3d34eu6m22',
    'bears19xesffdmzxuwn4gk2qy38k449mlh2jzud68nmk',
    'bears18qnrzfqctewrn2rgj3ckpjns37lu6h6kqeupv6',
    'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
    'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
    'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
    'bears1wcyf0qa2rregc6fqkg0hlv8rxxstk6t6q856nw',
    'bears1w6wxh59z054gjs7vcqkjwhqvtvln833e2p62zu',
    'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
    'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
    'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
    'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
    'bears1c8cx6hpf6v9u7kcq3wksjnp0cjpnl706vwmle7',
    'bears1cn473vld5f3c939wzqw9djfvdh0qwtsd63yen6',
    'bears1e73zmtklhzvqp5rzauvmrelpttk02tdk9d0xrm',
    'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
    'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
    'bears16dxqhz7xtwnumx0dp5972x7jdlmk3znjnydt0j',
    'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
    'bears16ln3s83z0n5dlwxnquqzqacudph2z44rtrgcrl',
    'bears1mf8jm5n58r4xp4w8jshpxh6t7a83e9zg2z86e9',
    'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
    'bears17tfqljhx8t7ekq97rcs82uzal5gctug4f9npdj',
    'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
    'bears1ppc0fejgcym8lllmuy7sww8me8xxgdzwztc6vn',
    'bears1pttye6xtndrkddqwsqzrjpf9fhq33qdp0f2rxq',
    'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
    'bears1zxmlj8y4hkcg98ntcjzklkv79vwp4euncafkmv',
    'bears1yrqaynef5sgmh290c989c77arny88hrn9t0h7q',
    'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
    'bears19cesx2xp3e6apwe5yxryj98hwt4uvcpu2ykxu4',
    'bears1xgfkkq8njunpwec62pfqws6hdylhxepc9h2er2',
    'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
    'bears1g2ghpsfhxsdzxvcunn3dy077hj3jjec33dxuym',
    'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
    'bears1fzaylj5s9zdrl6hqpectqeu43v6suk0vysy7aw',
    'bears1f0kuqqfsq89e4kz9h7hlzu7c7xhqj36lnjmcq0',
    'bears1fefkkrep3x2p99ezf0tpn2g3nxg5jz9e9u864d',
    'bears1t94rqkgxuhatsxxmfsrty0j7c3cznst0gwcht3',
    'bears1vrf40h6h3mj8uwx5atvru07hnndjykrzvt93pu',
    'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
    'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
    'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
    'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
    'bears1jjludszm6apfeqthfmslvvrd7zlkpeqlqfk9l4',
    'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
    'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
    'bears14am85tyuwzgld5v5stxzsut0rtkywzyt84ydxe',
    'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
    'bears1k7fjrdprzs89zt9wwd7tjj577hhlmtrxy3qvfx',
    'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
    'bears1h37kmfwk2hkj8ssnyzuvue82gpdqsly5ufm8q4',
    'bears1hlmfw8wj08a3fa4jwfkrgzpskn7my23u4xzane',
    'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
    'bears1edmwjmpsmmxycv92epdh4sunsvqa29fnapx5xp',
    'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
    'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
    'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
    'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
    'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
    'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
    'bears1lgj9g9jt2nu0xpr47tuhadhcd3e28gp0w6r2v9'
  ],
  [   // March
    'bears1pttye6xtndrkddqwsqzrjpf9fhq33qdp0f2rxq',
    'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
    'bears1952dyzydd3wjtqe3x8y0lq57k6gg2ngj3g0a5e',
    'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
    'bears1wde23h86vu5y7fsfhs85h5wsem9kckj7sny87c',
    'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
    'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
    'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
    'bears15axsadn29gmsn7r88a25pvn694yhqnvgsrcx32',
    'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
    'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
    'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
    'bears1ujdukzf00lyrkvrjv3a4zfjnv9r7zu0ly5jzkk',
    'bears1azjav327vs63e0hfly05dayespg7d2sk6tp5gj',
    'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
    'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
    'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
    'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
    'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
    'bears12rdpjdk78msweryvqfduscwcnh6754rm9ecfqk',
    'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
    'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
    'bears1wcyf0qa2rregc6fqkg0hlv8rxxstk6t6q856nw',
    'bears1wehlz8wrn2xx2h3ztfqckc6d4dldtepejhquag',
    'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
    'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
    'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
    'bears1eq7mq6g3ack4ff2gmjvnh7cug2q7l5y6ta9l56',
    'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
    'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
    'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
    'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
    'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
    'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
    'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
    'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
    'bears1yrqaynef5sgmh290c989c77arny88hrn9t0h7q',
    'bears1xgfkkq8njunpwec62pfqws6hdylhxepc9h2er2',
    'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
    'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
    'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
    'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
    'bears1vrf40h6h3mj8uwx5atvru07hnndjykrzvt93pu',
    'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
    'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
    'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
    'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
    'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
    'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
    'bears1hs6x75mcja0vyrlgpv4n9urms8a9ljuarfwyuu',
    'bears1hlmfw8wj08a3fa4jwfkrgzpskn7my23u4xzane',
    'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
    'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
    'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
    'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
    'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
    'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
    'bears1uadsx95595296vsht8fpv4n98dzankmnj8wc06',
    'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv'
  ],
  [   // April
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears18qnrzfqctewrn2rgj3ckpjns37lu6h6kqeupv6',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears15axsadn29gmsn7r88a25pvn694yhqnvgsrcx32',
  'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1uz90x7ntc5re5tpkmjp8dwgkhmj98t8m8ulq5e',
  'bears1azjav327vs63e0hfly05dayespg7d2sk6tp5gj',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1wcyf0qa2rregc6fqkg0hlv8rxxstk6t6q856nw',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1cn473vld5f3c939wzqw9djfvdh0qwtsd63yen6',
  'bears1eq7mq6g3ack4ff2gmjvnh7cug2q7l5y6ta9l56',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears1e73zmtklhzvqp5rzauvmrelpttk02tdk9d0xrm',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears1yrqaynef5sgmh290c989c77arny88hrn9t0h7q',
  'bears1y5nlxqgehkckapzx9lhnrh396ph0njzr3rzvm2',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
  'bears1vrf40h6h3mj8uwx5atvru07hnndjykrzvt93pu',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1uadsx95595296vsht8fpv4n98dzankmnj8wc06',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv'
  ],
  [ // May
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears18qnrzfqctewrn2rgj3ckpjns37lu6h6kqeupv6',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
  'bears1hlmfw8wj08a3fa4jwfkrgzpskn7my23u4xzane',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1uz90x7ntc5re5tpkmjp8dwgkhmj98t8m8ulq5e',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1wcyf0qa2rregc6fqkg0hlv8rxxstk6t6q856nw',
  'bears1wehlz8wrn2xx2h3ztfqckc6d4dldtepejhquag',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1eq7mq6g3ack4ff2gmjvnh7cug2q7l5y6ta9l56',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears1e73zmtklhzvqp5rzauvmrelpttk02tdk9d0xrm',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1zxmlj8y4hkcg98ntcjzklkv79vwp4euncafkmv',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears1y5nlxqgehkckapzx9lhnrh396ph0njzr3rzvm2',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears18mwtvutlegm0jvqsyqxls0qj0gztsu7cwsranm',
  'bears1g2ghpsfhxsdzxvcunn3dy077hj3jjec33dxuym',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1t2w20k5nps25dj5jpjxq4tyernnx4h57yn0gcl',
  'bears1vrf40h6h3mj8uwx5atvru07hnndjykrzvt93pu',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1mkxsdv4xquq94k2qv058ckmvfzgm8anjtvatwd',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1uadsx95595296vsht8fpv4n98dzankmnj8wc06',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv',
  ],
  [ // June
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears12n7j75z7fk736snp32g84ahumuqfnhjemccez6',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears1wxkvweazalxwh88ee8j65u88fv63h4vlu8chu2',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
  'bears1hlmfw8wj08a3fa4jwfkrgzpskn7my23u4xzane',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1uz90x7ntc5re5tpkmjp8dwgkhmj98t8m8ulq5e',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1fujvffa52fz2fexs2ws9tk7lxg7626cfpp3yx5',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1wcyf0qa2rregc6fqkg0hlv8rxxstk6t6q856nw',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1eq7mq6g3ack4ff2gmjvnh7cug2q7l5y6ta9l56',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears1e73zmtklhzvqp5rzauvmrelpttk02tdk9d0xrm',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1azvcrkgu2h0wffcnueyhzv6htx3vtlydcrmnyp',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1zxmlj8y4hkcg98ntcjzklkv79vwp4euncafkmv',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears1y5nlxqgehkckapzx9lhnrh396ph0njzr3rzvm2',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears1902drefezkr7s4t2y9fcppey6mwqr3h6zsn8dr',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears1g2ghpsfhxsdzxvcunn3dy077hj3jjec33dxuym',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1f0kuqqfsq89e4kz9h7hlzu7c7xhqj36lnjmcq0',
  'bears1t2w20k5nps25dj5jpjxq4tyernnx4h57yn0gcl',
  'bears1vrf40h6h3mj8uwx5atvru07hnndjykrzvt93pu',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1mkxsdv4xquq94k2qv058ckmvfzgm8anjtvatwd',
  ],
  [// July
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1uadsx95595296vsht8fpv4n98dzankmnj8wc06',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears1wxkvweazalxwh88ee8j65u88fv63h4vlu8chu2',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears16nw03rssfgz5y8te63cklkks6mn7vwzw2nfw5t',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1slnan5dhj7s9wkmuzx9597agu3q27e8u8acts9',
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears1fujvffa52fz2fexs2ws9tk7lxg7626cfpp3yx5',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1tkzpyz8fkwx7xsfyq97xe3vxxsp2mfy7m05pw3',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  ],
  [// August
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1uadsx95595296vsht8fpv4n98dzankmnj8wc06',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears135xyfltkc67w4axf53j06kwa0th9r7w8a2ruqp',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears1wxkvweazalxwh88ee8j65u88fv63h4vlu8chu2',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears1mvvmuwl9z8922knlsl350vdestsywlrj2l5tpj',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears148eq7w58dfsjvpz0nfs0kelhmayvdyfm3406zq',
  'bears1h9c4jyqhc3l0s33e4gz8vs5d8p4erdqz76ql9u',
  'bears1wde23h86vu5y7fsfhs85h5wsem9kckj7sny87c',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1eq7mq6g3ack4ff2gmjvnh7cug2q7l5y6ta9l56',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1fujvffa52fz2fexs2ws9tk7lxg7626cfpp3yx5',
  'bears16nw03rssfgz5y8te63cklkks6mn7vwzw2nfw5t',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1pttye6xtndrkddqwsqzrjpf9fhq33qdp0f2rxq',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears1azvcrkgu2h0wffcnueyhzv6htx3vtlydcrmnyp',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1t2w20k5nps25dj5jpjxq4tyernnx4h57yn0gcl',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  ],
  [// September
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears1wxkvweazalxwh88ee8j65u88fv63h4vlu8chu2',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears135xyfltkc67w4axf53j06kwa0th9r7w8a2ruqp',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  'bears1ktxpx73y688t8x62g320hmdu7v8ljds7zcynvs',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears1eaa97yfrfayz0044xvnxauvj4q25hs6tsfdn0r',
  'bears16nw03rssfgz5y8te63cklkks6mn7vwzw2nfw5t',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1793m0psj39zkcvjfgxakadcnu95cxu0ldtjgql',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1fujvffa52fz2fexs2ws9tk7lxg7626cfpp3yx5',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1wehlz8wrn2xx2h3ztfqckc6d4dldtepejhquag',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1azvcrkgu2h0wffcnueyhzv6htx3vtlydcrmnyp',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1pttye6xtndrkddqwsqzrjpf9fhq33qdp0f2rxq',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears18z5zqkql4a22xnlj63a8e2x9meaxcsuxsyg6xq',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1t2w20k5nps25dj5jpjxq4tyernnx4h57yn0gcl',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears14td6tar0rauq5h073e8du8rcqhnpjsnpypn39t',
  'bears14nfmtsktavarf8hyqjzxsj3vpws30ncfqwy6qf',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv',
  ],
  [// October
  'bears1pe28h9jgrmagtmgtlyfl0sauuhtdathwhth9z5',
  'bears1x4nd473vpddljeuj7jx5tkjgg5dky0y0ara93p',
  'bears1fet6p082wxqgt7e9xjp7x7gypagkaes4sltmwr',
  'bears12n7j75z7fk736snp32g84ahumuqfnhjemccez6',
  'bears12uev34cg442h9583e06rhe7dfuuekgs0v6y8z0',
  'bears1dsvnz64xt20s8hc72zu8d6zck896fj3lexceg4',
  'bears1wxkvweazalxwh88ee8j65u88fv63h4vlu8chu2',
  'bears109jav06xs7hfjhyxknejz5j2xjm32tkska5mxh',
  'bears106qw33e0ff0zuknt3g54hrthweqdj65w4x7ljc',
  'bears10myu4h4774n7clc7647rgwpqcqe6kmw5e9uz0c',
  'bears13x9d2tk96q283a09qs5u5j9uzm2uncrvz7q20k',
  'bears135xyfltkc67w4axf53j06kwa0th9r7w8a2ruqp',
  'bears13cecyjsr4w495638jv63ceuqxasw329u7sfa5n',
  'bears1j7mwh8wvq6j0drxn0tg7thqcj5d6xsr35g290f',
  'bears1kg56pmfth4zt3sap65fcms92k37nxaelpyc33m',
  'bears1ktxpx73y688t8x62g320hmdu7v8ljds7zcynvs',
  'bears1hz4lrfeegrpvgnrsf20mud2hcwhm6w5lfrsvxq',
  'bears1hlmfw8wj08a3fa4jwfkrgzpskn7my23u4xzane',
  'bears1ezasps5g5x37727v2vkymezqxy2x4alr742d5n',
  'bears1en9c8rg3ke66kydgnrc94xlqq2zrss4s665qnp',
  'bears16nw03rssfgz5y8te63cklkks6mn7vwzw2nfw5t',
  'bears164v2mktp7ekdzxrjg9l5gj4lu2qwhfr54qr6xz',
  'bears1munx00ajgty0s79hlpxyu44hd6vhuwau7rqma4',
  'bears1uz90x7ntc5re5tpkmjp8dwgkhmj98t8m8ulq5e',
  'bears17e4r7ygc4vasdj6xnr0806py4s92srwlt0zlgc',
  'bears17auaqltmymgnjjv07xk0fl0wdw9pcerhr8aprt',
  'bears177cnpc6mzdgvxs03scu0sydlszv9ql7s0vf7wh',
  'bears1qv75u6r44nz7lc9akr7hvc02jzv8rfu5c8puym',
  'bears1x3ew9ytwuqrcq7dt23eak0gnealngdqx0e05xq',
  'bears1ghnrasynhyk5ymsnp98yxrx7zja0sdfyy3rpx7',
  'bears1fujvffa52fz2fexs2ws9tk7lxg7626cfpp3yx5',
  'bears1v89m2s9apen2py2vz7h5v5cvzsw85g0d8zt2jx',
  'bears1wfwyezkz5h5u0uugk9xsnqdcn0pqf0knmr9jng',
  'bears1wh7gfmf8ffwgfu3rskuxn4fqpy2j5kl359spdn',
  'bears1wehlz8wrn2xx2h3ztfqckc6d4dldtepejhquag',
  'bears13dwg48hcsqca666lfhudh3kkxepkfhpafjc36j',
  'bears1nfhapr70pc6cyu6m3j7haqgxg6mw8ccjyp6lc0',
  'bears1nw3ear08pkh6fpnuarmjlwkmd4zykf2ywst379',
  'bears1hehrt06vlpfgxhx3eurz0wlr83az3q053pw3tr',
  'bears1e6pjcw8974m5wqegq4telndm6mcaeemrre4y0e',
  'bears16z7y0yjujjew2lvpgrxlch7pug4dky36n3zh7r',
  'bears16v8wm9jcdsqws4vq4sshuvqlwu7nq9ah6685qm',
  'bears16smz8n9aw60r5rme57mpc94mvnfv039sf0hgv0',
  'bears1mdnmgztl03kmv9dg2k3judqpufjqplsy37cwsc',
  'bears1azvcrkgu2h0wffcnueyhzv6htx3vtlydcrmnyp',
  'bears1l8yfdhjj4vwrmnt5jd2sq63zstpmr6vc33fh0v',
  'bears1q7dchflhvz3nz320l4fgxjax9mqkt9wd0rknsn',
  'bears1pttye6xtndrkddqwsqzrjpf9fhq33qdp0f2rxq',
  'bears1paxcex0vrp8ap4n74aq95djgwm22gysxrl2mf9',
  'bears1z9p2suyu4vetjaywn9hv82ugxnhjgudfkjs20z',
  'bears1zxn36xcst42tq8ne84xkljp8cs2w7kap8uqj38',
  'bears1rkwp4njrzt96sm7j0qn8q32cwc6rkvardcfk85',
  'bears19zekvu4u7cand59yv0f8wpxcr5js5nsf62kt0h',
  'bears18mwtvutlegm0jvqsyqxls0qj0gztsu7cwsranm',
  'bears1fq7wca0qvh7zcm0jkm0jmt44rrjjd8e5sk0zym',
  'bears1f0kuqqfsq89e4kz9h7hlzu7c7xhqj36lnjmcq0',
  'bears1t2w20k5nps25dj5jpjxq4tyernnx4h57yn0gcl',
  'bears10wkh86x8g3cyguvsdkrmv24f6hf2g6d5khdsme',
  'bears1sj67ga0n0pzkygk98ul72p4wwu9su3lgp7jf6k',
  'bears13murlhjtrxwk0p2w2z2jwwh55px7cf66zl3997',
  'bears1jfv2ajr6cy0aufw6h52luxrdrznazcd6yksmua',
  'bears1jh3hv5llzfjh77xfq39rkf8e8p7va435ay5295',
  'bears14td6tar0rauq5h073e8du8rcqhnpjsnpypn39t',
  'bears14nfmtsktavarf8hyqjzxsj3vpws30ncfqwy6qf',
  'bears1kn6gh3mxyepytjxmwcnxugx239akcrn9utustj',
  'bears1k53th5ycsn8yxm65ldclxj0mxej2k5sun0urat',
  'bears1ke2shzdfhjswm83cc6qx2cg6vch6calhdk0ccq',
  'bears1ccnzy7633ap8m3w0ldfjp9myurhk0yc0rszemg',
  'bears1ewg3zhqam6xpj2y04dq4rgmnxvp5jtgxdt2399',
  'bears1e4gvj9y387ua0msprwa6wf6e8y73txzsqvgn76',
  'bears16qngug3klu2g2d3q2g7hw7y8wefxksxc9ga3g6',
  'bears1myz9qwjqdla4wqmq2s25zyym3lmzlpeag5ymkc',
  'bears1mserxy2gsschtzcuqalhuqka2vmw4nym5pcyk3',
  'bears1mkxsdv4xquq94k2qv058ckmvfzgm8anjtvatwd',
  'bears1u4eup2mmz06gx5jlaptatscsxkatg3zj62y6cd',
  'bears1l9gky6mp3jd828xgmfv50g446u43mshsd88rvv',
  ],
  [],
  [],
];

export const GOLDEN_BEE_MONTH = 9;

export default {
  GOLDEN_BEE_ADDRESSES,
  GOLDEN_BEE_MONTH,
}